var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useFormContext } from "./Form";
import { withFormWrapper } from "./withFormWrapper";
import { DateTimeInput, FORMATS } from "./DateTimeInput";
import moment from "moment";
var Range;
(function (Range) {
    Range["Start"] = "start";
    Range["End"] = "end";
})(Range || (Range = {}));
var RawDateRangeInput = observer(function (_a) {
    var name = _a.name, onChange = _a.onChange, disabled = _a.disabled, label = _a.label, uniqueId = _a.uniqueId;
    var _b = useFormContext(), values = _b.values, formDisabled = _b.formDisabled, setIsDirty = _b.setIsDirty;
    var _c = useState({
        start: values.get("".concat(name, ".").concat(Range.Start)),
        end: values.get("".concat(name, ".").concat(Range.End)),
    }), dates = _c[0], setDates = _c[1];
    var handleChange = React.useCallback(function (selected, range) {
        var _a;
        var updatedDates = __assign(__assign({}, dates), (_a = {}, _a[range === Range.End ? "end" : "start"] = selected, _a));
        setDates(updatedDates);
        if (onChange) {
            onChange(updatedDates, values.get("".concat(name)));
        }
        if (typeof selected === "string") {
            values.set("".concat(name, ".").concat(range), selected);
            setIsDirty(true);
            return;
        }
        setIsDirty(true);
        values.set("".concat(name, ".").concat(range), selected ? selected.format(FORMATS["date"]) : undefined);
    }, [setIsDirty, values, name, dates]);
    var getValidStartDate = function (currentDate) {
        if (dates.end) {
            return moment(currentDate).isBefore(dates.end);
        }
        return moment(currentDate).isBefore("3000-01-01");
    };
    var getValidEndDate = function (currentDate) {
        if (dates.start) {
            return moment(currentDate).isAfter(dates.start);
        }
        return moment(currentDate).isAfter("1900-01-01");
    };
    return (React.createElement("div", { className: "date-range" },
        React.createElement(DateTimeInput, { name: "".concat(name, ".").concat(Range.Start), labelHidden: true, label: "".concat(label ? "".concat(label, " ") : "", "Start"), onChange: function (selected) { return handleChange(selected, Range.Start); }, disabled: formDisabled || disabled, type: "date", isValidDate: getValidStartDate, placeholder: !dates.end ? "Start" : undefined, uniqueId: uniqueId && "start-".concat(uniqueId) }),
        React.createElement(DateTimeInput, { name: "".concat(name, ".").concat(Range.End), labelHidden: true, label: "".concat(label ? "".concat(label, " ") : "", "End"), onChange: function (selected) { return handleChange(selected, Range.End); }, disabled: formDisabled || disabled, type: "date", isValidDate: getValidEndDate, placeholder: !dates.end ? "End" : undefined, uniqueId: uniqueId && "end-".concat(uniqueId) })));
});
export var DateRangeInput = withFormWrapper({
    WrappedComponent: RawDateRangeInput,
    options: "group",
});
